<template>
	<div
		class="modal fade"
		ref="modal"
		tabindex="-1"
		role="dialog"
		aria-hidden="true"
	>
		<div class="modal-dialog modal-panel" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h1 class="modal-title">{{ title }}</h1>
					<button
						class="modal-close"
						aria-label="Close"
						@click="close"
					>
						<i class="sk-icon-times"></i>
					</button>
				</div>
				<div class="modal-body">
					<BrandInfoBanner />
					<div class="tabs">
						<div
							v-for="tab in tabs"
							:key="tab.id"
							@click="tabClicked(tab)"
							class="tab"
							:class="{ 'selected-tab': tab.selected }"
						>
							<div class="tab-text">
								{{ tab.text }}
							</div>
							<div class="tab-quantity">
								{{ tab.quantity }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-body {
	align-items: flex-start;
	padding: 0px;
}

.modal-header {
	height: 55px;
	border: 1px solid var(--gR-white2);
}

.tabs {
	overflow: scroll;
	overscroll-behavior: contain;
	-webkit-overflow-scrolling: touch;
	max-height: 1600px;
	width: 100%;
	margin: 15px 0 9px 0;
}

.tab {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 22px 8px 12px;
	font-size: 13px;
	font-weight: var(--sk-font-normal);
	margin: 13px 0px;
	width: 100%;
	border-left: 3px solid var(--gR-white);
}

.tab-quantity {
	font-size: 11px;
}

.selected-tab {
	border-left: 3px solid var(--gR-base-90);
	font-weight: var(--sk-font-bold);
}
</style>

<script>
import mobileResponsivenessMixin from "@/mixins/mobile-responsiveness-mixin"
import skModalMixin from "@/mixins/sk-modal-mixin"
import BrandInfoBanner from "@/components/common/BrandInfoBanner.vue"

export default {
	name: "FilterModal",
	mixins: [mobileResponsivenessMixin, skModalMixin],
	data: function () {
		return {
			tabs: [],
			title: ""
		}
	},
	components: {
		BrandInfoBanner
	},
	methods: {
		handleOptions(options) {
			this.tabs = options.tabs
			this.title = options.title
		},
		tabClicked(tab) {
			this.$emit("tabClicked", tab)
			this.close()
		}
	}
}
</script>